import { render, staticRenderFns } from "./tentative.vue?vue&type=template&id=61eb1fbb&scoped=true&"
import script from "./tentative.vue?vue&type=script&lang=js&"
export * from "./tentative.vue?vue&type=script&lang=js&"
import style0 from "./tentative.vue?vue&type=style&index=0&id=61eb1fbb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61eb1fbb",
  null
  
)

export default component.exports